import * as React from "react";
import IconButton, { IconButtonProps } from "@mui/joy/IconButton";
import { useColorScheme as useJoyColorScheme } from "@mui/joy/styles";
import { useColorScheme as useMaterialColorScheme } from "@mui/material/styles";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeIcon from "@mui/icons-material/LightMode";
import { saveThemePreference } from "../../services/settingsService";

export default function ColorSchemeToggle(props: IconButtonProps) {
  const { sx, onClick, ...other } = props;
  const { mode, setMode: setMaterialMode } = useMaterialColorScheme();
  const { setMode: setJoyMode } = useJoyColorScheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => setMounted(true), []);

  if (!mounted) {
    return <IconButton size="sm" variant="outlined" color="neutral" disabled {...other} sx={sx} />;
  }

  return (
    <IconButton
      size="sm"
      variant="outlined"
      color="neutral"
      {...other}
      sx={[
        mode === "dark" ? { "& > *:first-of-type": { display: "none" } } : {},
        mode === "light" ? { "& > *:last-child": { display: "none" } } : {},
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      onClick={async (event) => {
        const next = mode === "light" ? "dark" : "light";
        setMaterialMode(next);
        setJoyMode(next);
        await saveThemePreference(next);
        onClick?.(event);
      }}
    >
      <DarkModeRoundedIcon />
      <LightModeIcon />
    </IconButton>
  );
}
